import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getInventoryStruct, setData} from './InventoryStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './InventoryAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateInventoryObj,addInventoryObj, setShowEditForInventory} from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';
import { addInventoryAPI } from 'api/OmsFactoryopsWebServices';



export default function InventoryEditFormImpl(){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getInventoryStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {inventoryDashboard} = useSelector((state)=>state.manufslice);
    const [inventoryId, setInventoryId] = useState(inventoryDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
        
    const {mfproductList} = useSelector((state)=>state.manufslice);
    const handleDynamicSelectedValueForproductid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'productname', e.target.value==0?'Select Item':mfproductList.find(obj => obj.id === e.target.value).title);
    }

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (inventoryId!==-1) {
            if (dataLoaded) return;
            getAPI(inventoryId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    },[]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const parsed = parseFloat(e.target.value);
        if (!isNaN(parsed) && e.target.value == parsed)
         updateTextValue(formValues, setFormValues,e);
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addInventoryObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForInventory(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateInventoryObj(obj));
        setNotification('Record with id['+inventoryId+'] has been updated successfully !!!');
        dispatch(setShowEditForInventory(false));
        
    }
    const failuerCallback = (errorMsg) => {
        dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const callCreateInventryObjAPISuccess = (apiResponse) =>{
        dispatch(setApiInProgress(false));
        dispatch(addInventoryObj(apiResponse.inventoryInfo));
        setNotification("Inventory for Product'"+formValues.productname.value+"' cretaed successfully !!!");
        dispatch(setShowEditForInventory(false));
    }
    const callCreateInventryObjAPI = (formValues) =>{
        dispatch(setApiInProgress(true));
        addInventoryAPI({
            "productId": parseInt(formValues.productid.value, 10),
            "stockCount": parseInt(formValues.itemcount.value, 10),
        }, callCreateInventryObjAPISuccess, failuerCallback);
    }

    const onSubmit=(e)=>{
        handleSubmit(e,inventoryId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateInventryObjAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'58vh'}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{inventoryId===-1?'Add':'Edit'} Product Inventory </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.title.placeholder}
                                    required={formValues.title.required}
                                    label={formValues.title.label}
                                    name={formValues.title.name}
                                    value={formValues.title.value}
                                    onChange={handleTextChange}
                                    error={formValues.title.error}
                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                   
                            <Grid item lg={8} xs={12} >
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">Product Name</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label="Product Name"
                                            name={formValues.productid.name}
                                            value={formValues.productid.value}
                                            onChange={handleDynamicSelectedValueForproductid}
                                            
                                            error={formValues.productid.error}
                                            helpertext={formValues.productid.error && formValues.productid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                mfproductList && mfproductList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.productname.placeholder}
                                    required={formValues.productname.required}
                                    label={formValues.productname.label}
                                    name={formValues.productname.name}
                                    value={formValues.productname.value}
                                    onChange={handleTextChange}
                                    error={formValues.productname.error}
                                    helperText={formValues.productname.error && formValues.productname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.itemcount.placeholder}
                                    required={formValues.itemcount.required}
                                    label={formValues.itemcount.label}
                                    name={formValues.itemcount.name}
                                    value={formValues.itemcount.value}
                                    onChange={handleTextChange}
                                    error={formValues.itemcount.error}
                                    helperText={formValues.itemcount.error && formValues.itemcount.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.orderid.placeholder}
                                    required={formValues.orderid.required}
                                    label={formValues.orderid.label}
                                    name={formValues.orderid.name}
                                    value={formValues.orderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.orderid.error}
                                    helperText={formValues.orderid.error && formValues.orderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.productorderid.placeholder}
                                    required={formValues.productorderid.required}
                                    label={formValues.productorderid.label}
                                    name={formValues.productorderid.name}
                                    value={formValues.productorderid.value}
                                    onChange={handleTextChange}
                                    error={formValues.productorderid.error}
                                    helperText={formValues.productorderid.error && formValues.productorderid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                <TextField size="Normal"
                                    placeholder={formValues.credititemid.placeholder}
                                    required={formValues.credititemid.required}
                                    label={formValues.credititemid.label}
                                    name={formValues.credititemid.name}
                                    value={formValues.credititemid.value}
                                    onChange={handleTextChange}
                                    error={formValues.credititemid.error}
                                    helperText={formValues.credititemid.error && formValues.credititemid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%',  }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{inventoryId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForInventory(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};